export enum SendGiftSteps {
  PAYMENT_METHOD,
  SUCCESS,
  FAILED
}
